import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// Services
import { StringsService } from '../../../core/_services/strings/strings.service';

// Models
import { InputBoxHeight, VerifiableInput } from '../../_model/input.model';

// Icons
import IconLibrary from '../../../shared/_libraries/icon-library.helper';

@Component({
  selector: 'pp-input',
  templateUrl: './input.component.html',
  styles: ':host { width: 100% }',
  imports: [CommonModule, ReactiveFormsModule, RouterModule, FontAwesomeModule],
})
export class InputComponent {

  readonly autoComplete = input<(string | null) | undefined>(null);
  readonly autoFocus = input(false);
  readonly form = input.required<FormGroup>();
  readonly formatPlaceholder = input<string>();
  readonly height = input(InputBoxHeight.Md);
  readonly id = input.required<string>();
  readonly ignoreValidation = input(false);
  readonly imagePath = input<string>();
  readonly invalid = input(false);
  readonly label = input<string>();
  readonly labelIsHidden = input(false);
  readonly placeholder = input('');
  readonly readOnly = input(false);
  readonly required = input(false);
  readonly standalone = input(false);
  readonly subLabel = input<string>();
  readonly type = input('text');
  readonly valid = input(false);
  readonly validations = input<{
    validator: string;
    message: string;
  }[]>([]);
  readonly verifiable = input<VerifiableInput | null>(null);

  readonly fileSelected = output<any>();
  readonly inputUpdate = output<any>();
  readonly verifyAction = output();

  // Aliases
  inputBoxHeight = InputBoxHeight;

  // Icons
  public iconLibrary = IconLibrary;

  // Services
  readonly strings = inject(StringsService);

  /**
   * Given a validator, returns the custom message passed.
   * @param validator a string representation of the validator.
   * @returns the custom message for the validator.
   * @memberof InputComponent
   */
  getValidationMessage(validator: string): string | undefined {
    return this.validations().find(v => v.validator === validator)?.message;
  }
}
